
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "0 0 44 44"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_tv_bf121289a8505dd9__cls-2,.icon_tv_bf121289a8505dd9__cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke:#fff}.icon_tv_bf121289a8505dd9__cls-2{stroke-width:2px}.icon_tv_bf121289a8505dd9__cls-3{stroke-width:2.2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon_tv_bf121289a8505dd9__Group_3445",
  transform: "translate(-233 -354)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon_tv_bf121289a8505dd9__Rectangle_2669",
  width: 44,
  height: 44,
  fill: "var(--theme-primary, #810ea9)",
  rx: 11,
  transform: "translate(233 354)"
}), /*#__PURE__*/React.createElement("g", {
  id: "icon_tv_bf121289a8505dd9__Group_3311",
  transform: "translate(245.095 368.666)"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon_tv_bf121289a8505dd9__Path_3299",
  d: "M743.262 524.279V522.6a.615.615 0 0 0-.591-.636h-18.387a.615.615 0 0 0-.592.636v12.275a.615.615 0 0 0 .592.636h18.387a.615.615 0 0 0 .591-.636v-4.366",
  className: "icon_tv_bf121289a8505dd9__cls-2",
  transform: "translate(-723.692 -521.967)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_tv_bf121289a8505dd9__Line_32",
  d: "M0 0h13.22",
  className: "icon_tv_bf121289a8505dd9__cls-2",
  transform: "translate(2.255 9.305)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_tv_bf121289a8505dd9__Line_33",
  d: "M0 .921.465 0",
  className: "icon_tv_bf121289a8505dd9__cls-3",
  transform: "translate(1.243 13.748)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_tv_bf121289a8505dd9__Line_34",
  d: "M.465.921 0 0",
  className: "icon_tv_bf121289a8505dd9__cls-3",
  transform: "translate(17.862 13.748)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_tv_bf121289a8505dd9__Path_3301",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.693,
  d: "M19.554 5.944a.525.525 0 0 1-.527-.513.5.5 0 0 1 .5-.513h.03a.513.513 0 0 1 0 1.025z"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\">\r\n    <defs>\r\n        <style>\r\n            .cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke:#fff}.cls-2{stroke-width:2px}.cls-3{stroke-width:2.2px}\r\n        </style>\r\n    </defs>\r\n    <g id=\"Group_3445\" transform=\"translate(-233 -354)\">\r\n        <rect id=\"Rectangle_2669\" width=\"44\" height=\"44\" fill=\"var(--theme-primary, #810ea9)\" rx=\"11\" transform=\"translate(233 354)\"/>\r\n        <g id=\"Group_3311\" transform=\"translate(245.095 368.666)\">\r\n            <path id=\"Path_3299\" d=\"M743.262 524.279V522.6a.615.615 0 0 0-.591-.636h-18.387a.615.615 0 0 0-.592.636v12.275a.615.615 0 0 0 .592.636h18.387a.615.615 0 0 0 .591-.636v-4.366\" class=\"cls-2\" transform=\"translate(-723.692 -521.967)\"/>\r\n            <path id=\"Line_32\" d=\"M0 0L13.22 0\" class=\"cls-2\" transform=\"translate(2.255 9.305)\"/>\r\n            <path id=\"Line_33\" d=\"M0 0.921L0.465 0\" class=\"cls-3\" transform=\"translate(1.243 13.748)\"/>\r\n            <path id=\"Line_34\" d=\"M0.465 0.921L0 0\" class=\"cls-3\" transform=\"translate(17.862 13.748)\"/>\r\n            <path id=\"Path_3301\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"0.693px\" d=\"M772.293 533.7a.525.525 0 0 1-.527-.513.5.5 0 0 1 .5-.513h.03a.513.513 0 0 1 0 1.025z\" transform=\"translate(-752.739 -527.756)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon_tv.bf121289a8505dd97971397eadbfc561.svg"),
        {
          React: SvgIconTv,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      